module.exports = __webpack_public_path__ + "static/img/2.b7f3854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news27/2.png
// module id = 6w33
// module chunks = 1